import { unitAt } from "@dailywars/core/engine";
import type { Coord, GameState, Unit } from "@dailywars/core/engine";

import { isOwnSelectableUnit } from "#/game/selection/transitions";
import type { SelectionState } from "#/game/selection/types";

function isJoinableTarget(selection: SelectionState, unitId: string): boolean {
  if (selection.mode !== "unit" && selection.mode !== "move-preview") return false;
  return selection.joinOptions.some((option) => option.targetId === unitId);
}

export function getSelectUnitHoverTarget({
  state,
  selection,
  hoveredTile,
  coarsePointer,
}: {
  state: GameState;
  selection: SelectionState;
  hoveredTile: Coord | null;
  coarsePointer: boolean;
}): Unit | null {
  if (coarsePointer || !hoveredTile) return null;

  const unit = unitAt(state, hoveredTile);
  if (!isOwnSelectableUnit(state, unit)) return null;
  if (isJoinableTarget(selection, unit.id)) return null;
  if (
    (selection.mode === "unit" || selection.mode === "move-preview") &&
    selection.unitId === unit.id
  ) {
    return null;
  }

  return unit;
}
